import type { AlphaEditModelsResponse } from "@nlc/shared-types";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getAlphaEditModels } from "../api/alphaEditor.api";

export function useAlphaEditModelsQuery(
  isEnabled: boolean,
): UseQueryResult<AlphaEditModelsResponse> {
  return useQuery({
    enabled: isEnabled,
    queryFn: getAlphaEditModels,
    queryKey: ["alpha-edit-models"],
  });
}
